import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, tap } from 'rxjs/operators';
import { publicMethods, baseUrl } from 'globals';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class QuotaManagementService {
  constructor(
    private http: HttpClient,
    private pubMethods: publicMethods,
    private auth: AuthenticationService
  ) {}

  isLoading = {
    loadingQuotaDetails: false,
    loadingTeamQuotaDetails: false,
    settingQuota: false
  };

  getOrganisationQuotaDetails(quotaType): Observable<any> {
    let params = new HttpParams().set('quotaType', quotaType);
    this.isLoading['loadingQuotaDetails'] = true;
    return this.http.post(baseUrl + '/return_organisation_quota_details/', params, this.auth.helperGetVerifiedPostDict())
      .pipe(tap(_ => (this.isLoading['loadingQuotaDetails'] = false)), catchError(
          this.pubMethods.handleError('getOrganisationQuotaDetails', [])
        )
      );
  }

  getTeamQuotaDetails(quotaType, teamId): Observable<any> {
    if (!teamId){teamId = ''};
    let params = new HttpParams().set('quotaType', quotaType).set('teamId', teamId);
    this.isLoading['loadingTeamQuotaDetails'] = true;
    return this.http.post(baseUrl + '/return_team_quota_details/', params, this.auth.helperGetVerifiedPostDict())
      .pipe(tap(_ => (this.isLoading['loadingTeamQuotaDetails'] = false)), catchError(
          this.pubMethods.handleError('getTeamQuotaDetails', [])
        )
      );
  }

  setUserQuota(quotaType, userId, quota): Observable<any> {
    let params = new HttpParams().set('quotaType', quotaType).set('userId', userId).set('quota', quota);
    this.isLoading['settingQuota'] = true;
    return this.http.post(baseUrl + '/set_user_quota/', params, this.auth.helperGetVerifiedPostDict())
      .pipe(tap(_ => (this.isLoading['settingQuota'] = false)), catchError(
          this.pubMethods.handleError('setUserQuota', [])
        )
      );
  }

  setTeamQuota(quotaType, teamId, quota): Observable<any> {
    let params = new HttpParams().set('quotaType', quotaType).set('teamId', teamId).set('quota', quota);
    this.isLoading['settingQuota'] = true;
    return this.http.post(baseUrl + '/set_team_quota/', params, this.auth.helperGetVerifiedPostDict())
      .pipe(tap(_ => (this.isLoading['settingQuota'] = false)), catchError(
          this.pubMethods.handleError('setTeamQuota', [])
        )
      );
  }

  equallyDistributeQuotas(quotaType): Observable<any> {
    let params = new HttpParams().set('quotaType', quotaType);
    this.isLoading['settingQuota'] = true;
    return this.http.post(baseUrl + '/equally_distribute_quotas_to_all_users/', params, this.auth.helperGetVerifiedPostDict())
      .pipe(tap(_ => (this.isLoading['settingQuota'] = false)), catchError(
          this.pubMethods.handleError('equallyDistributeQuotas', [])
        )
      );
  }


}
